import * as React from "react";
import { GafOktaManager } from "../../auth/gaf-okta-auth";
import { Redirect } from "react-router-dom";
import { HomeLoggedIn } from "../../components/home-logged-in";
import { HomeNotLoggedIn } from "../../components/home-not-logged-in";
import AccessDenied from "../../widgets/AccessDenied";
import constant from "../../constants/constantFile";
import Layout from "../Layout";

import { getImpersonationParamFromURL,handleRedirectAuth } from "../../utils/utils";

export class Home extends React.Component {
    state = {
        authenticated: null,
        error: null,
    };

    constructor(props: any) {
        super(props);
    }

    componentWillMount() {
        sessionStorage.setItem("requestURL", window.location.href);
    }

    componentDidMount() {
        if (window.localStorage) {
            if (!localStorage.getItem("firstLoad")) {
                localStorage["firstLoad"] = true;
                window.location.reload();
            } else localStorage.removeItem("firstLoad");
        }
        const authenticated = GafOktaManager.isAuthenticated;
        this.setState({ authenticated });
    }
    render() {
        const isImPersonationFlow = getImpersonationParamFromURL() ? true : false;
        return (
            <React.Fragment>
                {isImPersonationFlow ? (
                    <Layout>
                        <AccessDenied
                            type={"error"}
                            message={constant.impersonationAccessDeniedMessage}
                            alertBoxClose={handleRedirectAuth}
                        />
                    </Layout>
                ) : this.state.authenticated ? (
                    <HomeLoggedIn />
                ) : (
                    <HomeNotLoggedIn />
                )}
            </React.Fragment>
        );
    }
}
